import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import {Row, Col, Alert} from 'react-bootstrap';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import { CONFIG } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import {Doughnut,Radar, Polar} from 'react-chartjs-2';
import './peminatan.css';
import response from './resp.json'

class ReportPeminatan extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            isFetching: false,
            alertShow: false,            
            resMessage: '',
            listMapel: [],
            detail: {},
            detailSekolah: {},
            detailNon : {},
            placeIpa: [],
            placeIps: [],
            placeBhs: [],
            blmSelesai: []
        };
    }

    componentDidMount(){
        document.title = "Report Peminatan";
        // response props
        console.log(this.props)
        if(!__.isEmpty(this.props.response)){
            if(this.props.response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    detailSekolah: this.props.response.data.data.detailSekolah,
                    detail: this.props.response.data.data.detail,
                    detailNon: this.props.response.data.data.detailNon,
                    listMapel: this.props.response.data.data.listMapel,
                    placeIpa: this.props.response.data.data.placeIpa,
                    placeIps: this.props.response.data.data.placeIps,
                    placeBhs: this.props.response.data.data.placeBhs,
                    placeAgama: this.props.response.data.data.placeAgama,
                    blmSelesai: this.props.response.data.data.blmSelesai
                })
            }
        }else{
            // this.props.tutupReport();
            this.setState({
                detailSekolah: response.data.detailSekolah,
                detail: response.data.detail,
                detailNon: response.data.detailNon,
                listMapel: response.data.listMapel,
                placeIpa: response.data.placeIpa,
                placeIps: response.data.placeIps,
                placeBhs: response.data.placeBhs,
                placeAgama: response.data.placeAgama,
                blmSelesai: response.data.blmSelesai
            })
        }
    }

    renderChartRekomendasi(type, detail){
        let data = [];
        let label =[];
        if(this.state.detailSekolah.kodeJenjangSekolah === "MA"){
            if(type==='rekom'){
                data = [detail.percentRecomIpa, detail.percentRecomIps, detail.percentRecomBhs, detail.percentRecomAgama];
            }else{
                data = [detail.percentPlaceIpa, detail.percentPlaceIps, detail.percentPlaceBhs, detail.percentPlaceAgama];
            }
            label = ['IPA %', 'IPS %', 'Bahasa %', 'Agama %'];
        }else{
            if(type==='rekom'){
                data = [detail.percentRecomIpa, detail.percentRecomIps, detail.percentRecomBhs];
            }else{
                data = [detail.percentPlaceIpa, detail.percentPlaceIps, detail.percentPlaceBhs];
            }
            label = ['IPA %', 'IPS %', 'Bahasa %'];
        }
       
        return(
            <>
                <Doughnut
                    data={{
                        labels: label,
                        datasets: [{
                            label: 'Judul',
                            data: data,
                            backgroundColor: [
                                '#FFD4DB',
                                '#D3B5E5',
                                '#BBE7FE',
                                '#EFF1DB'
                            ]
                        }]
                    }}
                    options = {{  
                        legend: {
                            labels: {                                
                                fontSize: 12,
                            },
                            position:  'bottom'
                        }                       
                    }}
                />
                
            </>             
        )
    }

    renderChartDetailLs(bawah, tengah, atas){
        let data = [bawah, tengah, atas];
        let label = ['Rata Bawah', 'Rata-Rata', 'Rata Atas'];
    
        return(
            <>
                <Doughnut
                    data={{
                        labels: label,
                        datasets: [{
                            label: 'Judul',
                            data: data,
                            backgroundColor: [
                                '#FF5765',
                                '#FFDB15',
                                '#A8E10C'
                            ]
                        }]
                    }}
                    options = {{  
                        legend: {
                            labels: {                                
                                fontSize: 12,
                            },
                            position:  'right'
                        }                       
                    }}
                />
                
            </>             
        )
    }

    renderSkorMapelSiswa(arr, siswa){
        return(
            arr.map((mp, m)=>
                siswa.listSkor.map((skor, sw)=>
                    {                        
                        if(mp.namaMapelSingkatan === skor.namaMataPelajaran){
                            return(
                                <td className="tabel-siswa-placement-center">{skor.skor}</td>
                            )
                        }
                        if(skor.namaMataPelajaran === null){
                            return(
                                <td className="tabel-siswa-placement-center">-</td>
                            )
                        }
                    }
                )
            )
        )
    }

    componentDidUpdate(){
        console.clear();
        console.log(response.data.detailSekolah.kodeJenjangSekolah);
    }

    render() { 
        const {listMapel, detail, detailNon, placeIpa, placeIps, placeBhs, placeAgama, detailSekolah, blmSelesai} = this.state;
        return (
            <div className="container-fluid" style={{padding: '10px', width: '1000px' }}>
                <LoaderModal isFetching={this.state.isFetching}/> 
                    {this.loadAlert()}

                    <Row>
                        <Col>
                            <img className="header-left" src="https://www.eduprime.co.id/static/images/eduprime_tulisan_hitam.png" style={{width : "20%"}}/>
                            <b className="header-right ">
                                ASESMEN PEMINATAN<br />{detail.namaSekolah}
                            </b>
                        </Col>
                    </Row>
                    <br />

                    <Row>
                        <Col>
                            <b className="header-text-left">Tanggal Asesmen: {detail.tglUjian}</b>
                            <b className="header-text-right">&nbsp;{detail.jumlahSiswa} Siswa</b>
                            <img src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/peminatan/SISWA.png" style={{width : "8%", float: "right"}}/>
                        </Col>
                    </Row>
                    <br />
                    
                    <Row>
                        <Col>
                            <p className="text-kontent">
                                <b className="text-kuning">Recommendation</b> berdasarkan hasil tes siswa, sedangkan <b className="text-kuning">Placement</b> berdasarkan hasil tes siswa yang
                                disesuaikan dengan kuota sekolah melalui teknik konversi.
                            </p>
                        </Col>
                    </Row>
                    <br />
                    
                    <Row>
                        <Col>
                            <p className="text-center"><h3><b className="text-kuning">RECOMMENDATION</b></h3></p>
                            <p className="text-center"><h3 className="text-kuning">Berdasarkan Hasil Tes</h3></p>
                        </Col>
                        <Col>
                            <p className="text-center"><h3><b className="text-kuning">PLACEMENT</b></h3></p>
                            <p className="text-center"><h3 className="text-kuning">Berdasarkan tes dan kuota</h3></p>
                        </Col>
                    </Row>
                   
                    <Row>
                        <Col>
                            <table width="100%">
                                {detail.recomIpa != null &&
                                    <tr>
                                        <td className="rekomendasi-tabel-mapel"><img src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/peminatan/IPA.png" style={{width : "20%" }}/></td>
                                        <td width="50%" className="text-abu">{detail.recomIpa} Siswa</td>
                                    </tr>
                                }
                                <tr>&nbsp;</tr>
                                {detail.recomIps != null &&
                                    <tr>
                                        <td className="rekomendasi-tabel-mapel"><img src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/peminatan/IPS.png" style={{width : "20%" }}/></td>
                                        <td width="50%" className="text-abu">{detail.recomIps} Siswa</td>
                                    </tr>
                                }
                                <tr>&nbsp;</tr>
                                {detail.recomBhs != null &&
                                    <tr>
                                        <td className="rekomendasi-tabel-mapel"><img src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/peminatan/BAHASA.png" style={{width : "20%" }}/></td>
                                        <td width="50%" className="text-abu">{detail.recomBhs} Siswa</td>
                                    </tr>
                                }
                                <tr>&nbsp;</tr>
                                {detail.recomAgama != null &&
                                    <tr>
                                        <td className="rekomendasi-tabel-mapel"><img src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/peminatan/AGAMA.png" style={{width : "23%" }}/></td>
                                        <td width="50%" className="text-abu">{detail.recomAgama} Siswa</td>
                                    </tr>
                                }
                            </table>
                        </Col>
                        <Col>
                            <table width="100%">
                                {detail.jumPlaceIpa != null &&
                                    <tr>
                                        <td className="rekomendasi-tabel-mapel"><img src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/peminatan/IPA.png" style={{width : "20%" }}/></td>
                                        <td width="50%" className="text-abu">{detail.jumPlaceIpa} Siswa</td>
                                    </tr>
                                }
                                <tr>&nbsp;</tr>
                                {detail.jumPlaceIps != null &&
                                    <tr>
                                        <td className="rekomendasi-tabel-mapel"><img src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/peminatan/IPS.png" style={{width : "20%" }}/></td>
                                        <td width="50%" className="text-abu">{detail.jumPlaceIps} Siswa</td>
                                    </tr>
                                }
                                <tr>&nbsp;</tr>
                                {detail.jumPlaceBhs != null &&
                                    <tr>
                                        <td className="rekomendasi-tabel-mapel"><img src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/peminatan/BAHASA.png" style={{width : "20%" }}/></td>
                                        <td width="50%" className="text-abu">{detail.jumPlaceBhs} Siswa</td>
                                    </tr>
                                }
                                <tr>&nbsp;</tr>
                                {detail.jumPlaceAgama != null &&
                                    <tr>
                                        <td className="rekomendasi-tabel-mapel"><img src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/peminatan/AGAMA.png" style={{width : "23%" }}/></td>
                                        <td width="50%" className="text-abu">{detail.jumPlaceAgama} Siswa</td>
                                    </tr>
                                }
                            </table>
                        </Col>
                    </Row>
                    <br />
                    
                    <Row>
                        <Col sm={6}>{this.renderChartRekomendasi('rekom', detail)}</Col>
                        <Col sm={6}>{this.renderChartRekomendasi('placement', detail)}</Col>
                    </Row>

                    {/* DETAIL RATA MAPEL */}
                    <br />
                    <Row>
                        <Col sm={7}>
                            <table width="100%">
                                {/* <tr>
                                    <td>Matematika</td>
                                    <td width="70%" style={{verticalAlign: 'middle!important'}}>
                                        <div className="w3-progress-container w3-round-xlarge text-center" >
                                            <div className="w3-progressbar w3-round-xlarge" style={{width: "37%", "background-color": "#EAC5B0"}}>
                                                <span style={{padding: '0 10px',fontSize: '14px'}}>37%</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr> */}
                                {!__.isEmpty(listMapel) &&
                                    listMapel.map((val, i)=>
                                        <tr>
                                            <td>{val.namaMapel}</td>
                                            <td width="70%" style={{verticalAlign: 'middle!important'}}>
                                                <div className="w3-progress-container w3-round-xlarge text-center" >
                                                    <div className="w3-progressbar w3-round-xlarge" style={{width: Number(val.rataMapel).toFixed(2)+"%", "backgroundColor": "#FFDB15"}}>
                                                        <span style={{padding: '0 10px',fontSize: '14px'}}>{val.rataMapel}%</span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                            </table>
                        </Col>
                        <Col sm={5}>
                            <table width="100%">
                                <tr>
                                    <td colSpan="2"><b className="judul-learning">LEARNING STYLE</b></td>
                                </tr>
                                <tr>
                                    <td width="35%"><img src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/peminatan/VISUAL.png" style={{width : "55%" }}/></td>
                                    <td className="text-merah"><b className="size-skor-ls">{detailNon.percenVisual} %</b><br /> {detailNon.jumVisual} siswa</td>
                                </tr>
                                <tr>
                                    <td><img src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/peminatan/AUDITORI.png" style={{width : "55%" }}/></td>
                                    <td className="text-merah"><b className="size-skor-ls">{detailNon.percenAuditori} %</b><br /> {detailNon.jumAuditori} siswa</td>
                                </tr>
                                <tr>
                                    <td><img src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/peminatan/KINESTETIK.png" style={{width : "55%" }}/></td>
                                    <td className="text-merah"><b className="size-skor-ls">{detailNon.percenKinestetik} %</b><br /> {detailNon.jumKinestetik} siswa</td>
                                </tr>
                            </table>
                        </Col>
                    </Row>
                    <br />

                    {/* GRAFIK DETAIL LS */}
                    <Row>
                        <Col>
                            <table width="100%">
                                <tr>
                                    <td className="text-center">ADVERSITY QUOTIENT <br /> (Daya juang dalam persentase)</td>
                                    <td className="text-center">EMOTIONAL QUOTIENT <br /> (Kecerdasan emosional dalam persentase)</td>
                                    <td className="text-center">ACHIEVEMENT MOTIVATIONAL <br /> (Motivasi Berprestasi dalam persentase)</td>
                                </tr>
                                <tr>
                                    <td className="text-center">{this.renderChartDetailLs(detailNon.jumAqBawah, detailNon.jumAqTengah, detailNon.jumAqAtas)}</td>
                                    <td className="text-center">{this.renderChartDetailLs(detailNon.jumEqBawah, detailNon.jumEqTengah, detailNon.jumEqAtas)}</td>
                                    <td className="text-center">{this.renderChartDetailLs(detailNon.jumAmBawah, detailNon.jumAmTengah, detailNon.jumAmAtas)}</td>
                                </tr>
                            </table>
                        </Col>
                    </Row>
                    <br />
                    <div class="pagebreak"> </div>

                    {/* TABEL SISWA  PLACEMENT IPA*/}
                    {!__.isEmpty(placeIpa) && <>
                        <Row>
                            <Col sm={6}>
                                <b>PLACEMENT IPA</b>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-colat" /> &nbsp;: Rata Bawah
                                </div>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-kuning" /> &nbsp;: Rata Rata
                                </div>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-hijau" /> &nbsp;: Rata Atas
                                </div>
                            </Col>
                        </Row>
                        
                        <Row>
                        <Col>
                            <table width="100%" border="1">
                                <thead className="head-mapel-siswa">
                                    <tr>
                                        <th rowSpan="2">No</th>
                                        <th rowSpan="2">Nama Siswa</th>
                                        {listMapel.map((val)=><th rowSpan="2">{val.namaMapelSingkatan}</th>)}
                                        <th rowSpan="2">Recommendation</th>
                                        <th rowSpan="2">Placement</th>
                                        <th rowSpan="2">Learning Style</th>
                                        <th colSpan="3">Psychology Test</th>
                                    </tr>
                                    <tr>
                                        <th>AQ</th>
                                        <th>EQ</th>
                                        <th>AM</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!__.isEmpty(placeIpa) &&
                                        placeIpa.map((sk, i)=>
                                           <tr>
                                                <td className="tabel-siswa-placement">{i+1}</td>
                                                <td className="tabel-siswa-placement">{sk.namaSiswa}</td>
                                                {this.renderSkorMapelSiswa(listMapel, sk)}
                                                <td className="tabel-siswa-placement-center">{sk.result}</td>
                                                <td className="tabel-siswa-placement-center">
                                                    <div className="row">
                                                        {sk.result == sk.placement ? <div className="ling-hijau" style={{"marginLeft":"25%"}}/> : <div className="ling-kuning" style={{"marginLeft":"25%"}}/>}
                                                        &nbsp;{sk.placement}
                                                    </div>
                                                </td>
                                                <td className="tabel-siswa-placement-center">{sk.resultLs == null ? '-' : sk.resultLs }</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultAq == null ? '-' : sk.resultAq } />{sk.resultAq == null && '-'}</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultEq == null ? '-' : sk.resultEq } />{sk.resultEq == null && '-'}</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultAm == null ? '-' : sk.resultAm } />{sk.resultAm == null && '-'}</td>
                                           </tr> 
                                        )
                                    }
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <br />
                    <div class="pagebreak"> </div>
                    </>}

                    {/* TABEL SISWA  PLACEMENT IPS*/}
                    {!__.isEmpty(placeIps) && <>
                        <Row>
                            <Col sm={6}>
                                <b>PLACEMENT IPS</b>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-colat" /> &nbsp;: Rata Bawah
                                </div>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-kuning" /> &nbsp;: Rata Rata
                                </div>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-hijau" /> &nbsp;: Rata Atas
                                </div>
                            </Col>
                        </Row>
                        
                        <Row>
                        <Col>
                            <table width="100%" border="1">
                                <thead className="head-mapel-siswa">
                                    <tr>
                                        <th rowSpan="2">No</th>
                                        <th rowSpan="2">Nama Siswa</th>
                                        {listMapel.map((val)=><th rowSpan="2">{val.namaMapelSingkatan}</th>)}
                                        <th rowSpan="2">Recommendation</th>
                                        <th rowSpan="2">Placement</th>
                                        <th rowSpan="2">Learning Style</th>
                                        <th colSpan="3">Psychology Test</th>
                                    </tr>
                                    <tr>
                                        <th>AQ</th>
                                        <th>EQ</th>
                                        <th>AM</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!__.isEmpty(placeIps) &&
                                        placeIps.map((sk, i)=>
                                           <tr>
                                                <td className="tabel-siswa-placement">{i+1}</td>
                                                <td className="tabel-siswa-placement">{sk.namaSiswa}</td>
                                                {this.renderSkorMapelSiswa(listMapel, sk)}
                                                <td className="tabel-siswa-placement-center">{sk.result}</td>
                                                <td className="tabel-siswa-placement-center">
                                                    <div className="row">
                                                        {sk.result == sk.placement ? <div className="ling-hijau" style={{"marginLeft":"25%"}}/> : <div className="ling-kuning" style={{"marginLeft":"25%"}}/>}
                                                        &nbsp;{sk.placement}
                                                    </div>
                                                </td>
                                                <td className="tabel-siswa-placement-center">{sk.resultLs == null ? '-' : sk.resultLs }</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultAq == null ? '-' : sk.resultAq } />{sk.resultAq == null && '-'}</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultEq == null ? '-' : sk.resultEq } />{sk.resultEq == null && '-'}</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultAm == null ? '-' : sk.resultAm } />{sk.resultAm == null && '-'}</td>
                                           </tr> 
                                        )
                                    }
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <br />
                    <div class="pagebreak"> </div>
                    </>}
                    

                    {/* TABEL SISWA  PLACEMENT BHS*/}
                    {!__.isEmpty(placeBhs) && <>
                        <Row>
                            <Col sm={6}>
                                <b>PLACEMENT BAHASA</b>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-colat" /> &nbsp;: Rata Bawah
                                </div>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-kuning" /> &nbsp;: Rata Rata
                                </div>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-hijau" /> &nbsp;: Rata Atas
                                </div>
                            </Col>
                        </Row>
                        
                        <Row>
                        <Col>
                            <table width="100%" border="1">
                                <thead className="head-mapel-siswa">
                                    <tr>
                                        <th rowSpan="2">No</th>
                                        <th rowSpan="2">Nama Siswa</th>
                                        {listMapel.map((val)=><th rowSpan="2">{val.namaMapelSingkatan}</th>)}
                                        <th rowSpan="2">Recommendation</th>
                                        <th rowSpan="2">Placement</th>
                                        <th rowSpan="2">Learning Style</th>
                                        <th colSpan="3">Psychology Test</th>
                                    </tr>
                                    <tr>
                                        <th>AQ</th>
                                        <th>EQ</th>
                                        <th>AM</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!__.isEmpty(placeBhs) &&
                                        placeBhs.map((sk, i)=>
                                           <tr>
                                                <td className="tabel-siswa-placement">{i+1}</td>
                                                <td className="tabel-siswa-placement">{sk.namaSiswa}</td>
                                                {this.renderSkorMapelSiswa(listMapel, sk)}
                                                <td className="tabel-siswa-placement-center">{sk.result}</td>
                                                <td className="tabel-siswa-placement-center">
                                                    <div className="row">
                                                        {sk.result == sk.placement ? <div className="ling-hijau" style={{"marginLeft":"25%"}}/> : <div className="ling-kuning" style={{"marginLeft":"25%"}}/>}
                                                        &nbsp;{sk.placement}
                                                    </div>
                                                </td>
                                                <td className="tabel-siswa-placement-center">{sk.resultLs == null ? '-' : sk.resultLs }</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultAq == null ? '-' : sk.resultAq } />{sk.resultAq == null && '-'}</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultEq == null ? '-' : sk.resultEq } />{sk.resultEq == null && '-'}</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultAm == null ? '-' : sk.resultAm } />{sk.resultAm == null && '-'}</td>
                                           </tr> 
                                        )
                                    }
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <br />
                    <div class="pagebreak"> </div>
                    </>}

                    {/* TABEL SISWA  PLACEMENT AGAMA*/}
                    {!__.isEmpty(placeAgama) && <>
                        <Row>
                            <Col sm={6}>
                                <b>PLACEMENT AGAMA</b>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-colat" /> &nbsp;: Rata Bawah
                                </div>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-kuning" /> &nbsp;: Rata Rata
                                </div>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-hijau" /> &nbsp;: Rata Atas
                                </div>
                            </Col>
                        </Row>
                        
                        <Row>
                        <Col>
                            <table width="100%" border="1">
                                <thead className="head-mapel-siswa">
                                    <tr>
                                        <th rowSpan="2">No</th>
                                        <th rowSpan="2">Nama Siswa</th>
                                        {listMapel.map((val)=><th rowSpan="2">{val.namaMapelSingkatan}</th>)}
                                        <th rowSpan="2">Recommendation</th>
                                        <th rowSpan="2">Placement</th>
                                        <th rowSpan="2">Learning Style</th>
                                        <th colSpan="3">Psychology Test</th>
                                    </tr>
                                    <tr>
                                        <th>AQ</th>
                                        <th>EQ</th>
                                        <th>AM</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!__.isEmpty(placeAgama) &&
                                        placeAgama.map((sk, i)=>
                                           <tr>
                                                <td className="tabel-siswa-placement">{i+1}</td>
                                                <td className="tabel-siswa-placement">{sk.namaSiswa}</td>
                                                {this.renderSkorMapelSiswa(listMapel, sk)}
                                                <td className="tabel-siswa-placement-center">{sk.result}</td>
                                                <td className="tabel-siswa-placement-center">
                                                    <div className="row">
                                                        {sk.result == sk.placement ? <div className="ling-hijau" style={{"marginLeft":"25%"}}/> : <div className="ling-kuning" style={{"marginLeft":"25%"}}/>}
                                                        &nbsp;{sk.placement}
                                                    </div>
                                                </td>
                                                <td className="tabel-siswa-placement-center">{sk.resultLs == null ? '-' : sk.resultLs }</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultAq == null ? '-' : sk.resultAq } />{sk.resultAq == null && '-'}</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultEq == null ? '-' : sk.resultEq } />{sk.resultEq == null && '-'}</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultAm == null ? '-' : sk.resultAm } />{sk.resultAm == null && '-'}</td>
                                           </tr> 
                                        )
                                    }
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    </>}
                    <br />

                    
                    {/* TABEL SISWA  YANG BELUM SELESAI / BLM MENGERJAKAN SEMUA*/}
                    {!__.isEmpty(blmSelesai) && <>
                        <Row>
                            <Col sm={6}>
                                <b>Daftar Siswa belum mengerjakan atau belum selesai Test</b>
                            </Col>
                            {/* <Col sm={2}>
                                <div className="row">
                                    <div className="ling-colat" /> &nbsp;: Rata Bawah
                                </div>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-kuning" /> &nbsp;: Rata Rata
                                </div>
                            </Col>
                            <Col sm={2}>
                                <div className="row">
                                    <div className="ling-hijau" /> &nbsp;: Rata Atas
                                </div>
                            </Col> */}
                        </Row>
                        
                        <Row>
                        <Col>
                            <table width="100%" border="1">
                                <thead className="head-mapel-siswa-belum-selesai">
                                    <tr>
                                        <th rowSpan="2">No</th>
                                        <th rowSpan="2">Nama Siswa</th>
                                        {listMapel.map((val)=><th rowSpan="2">{val.namaMapelSingkatan}</th>)}
                                        {/* <th rowSpan="2">Recommendation</th>
                                        <th rowSpan="2">Placement</th> */}
                                        <th rowSpan="2">Learning Style</th>
                                        <th colSpan="3">Psychology Test</th>
                                    </tr>
                                    <tr>
                                        <th>AQ</th>
                                        <th>EQ</th>
                                        <th>AM</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!__.isEmpty(blmSelesai) &&
                                        blmSelesai.map((sk, i)=>
                                           <tr>
                                                <td className="tabel-siswa-placement">{i+1}</td>
                                                <td className="tabel-siswa-placement">{sk.namaSiswa}</td>
                                                {this.renderSkorMapelSiswa(listMapel, sk)}
                                                {/* <td className="tabel-siswa-placement-center">{sk.result}</td>
                                                <td className="tabel-siswa-placement-center">
                                                    <div className="row">
                                                        {sk.result == sk.placement ? <div className="ling-hijau" style={{"marginLeft":"25%"}}/> : <div className="ling-kuning" style={{"marginLeft":"25%"}}/>}
                                                        &nbsp;{sk.placement}
                                                    </div>
                                                </td> */}
                                                <td className="tabel-siswa-placement-center">{sk.resultLs == null ? '-' : sk.resultLs }</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultAq == null ? '-' : sk.resultAq } />{sk.resultAq == null && '-'}</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultEq == null ? '-' : sk.resultEq } />{sk.resultEq == null && '-'}</td>
                                                <td className="tabel-siswa-placement-center"><div className={sk.resultAm == null ? '-' : sk.resultAm } />{sk.resultAm == null && '-'}</td>
                                           </tr> 
                                        )
                                    }
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    </>}
                    <br />

                    <div id="btn_print">                        
                        <div className="fixed_button">
                            <button className="btn btn-outline-danger pull-left" title="Kembali" style={{marginLeft:'1em'}} onClick={() => this.props.tutupReport()}>
                                <li className="fa fa-arrow-left"></li>
                            </button>
                            &nbsp;
                            <button className="btn btn-outline-primary  pull-right" title="Print Report" style={{marginRight:'1em'}} onClick={() => window.print()}>
                                <li className="fa fa-print"></li>
                            </button>
                        </div>     
                    </div>   


            </div>
        );
    }

    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        }
    }
}
 
const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(ReportPeminatan); 
